/*
 * Static PD inventory — the data product supplied in
 * "Inventory Data for BMS Owned Materials.xlsx", held here until the upload
 * that writes it to cmo_inventory exists.
 *
 * SHAPE: identical to what the inventoryStatusDetails selector returns, so the
 * screen renders it through exactly the same path as live data — same grouping,
 * same pagination, same columns, same expand/collapse. Nothing downstream of
 * the selector knows the difference.
 *
 * 459 rows from the five product sheets (BSQ / BSR / BSZ / BST / BQC), grouped
 * into 271 material rows across 20 batches. The sheet merges CMO - MFG Plant,
 * Batch Number, CMO Material Code / Description and Material Type down each
 * block; those were forward-filled, without which 95% of the plant and batch
 * cells would be blank. The ERP dump sheet ("Stock as on 3rd Sept") is not
 * part of this — different columns, not what the screen shows.
 *
 * COLUMN MAPPING — the sheet's four quantity columns onto the fields the
 * screen already reads for them:
 *     Batch Qty.       -> onHandAvailableQuantity
 *     Approved Qty.    -> cmoOnHandAvailableQuantity
 *     Rejected Qty.    -> netAvailableQuantity
 *     Quarantine Qty.  -> committedQuantity
 *
 * TO TURN IT OFF: set USE_STATIC_PD_INVENTORY to false. That is the whole
 * switch — the screen goes straight back to the API with no other edit.
 */

// Flag. true  -> the screen shows the data below and never the API's.
//       false -> the API's data, exactly as before this file existed.
export const USE_STATIC_PD_INVENTORY = true;

export const STATIC_PD_INVENTORY = {
  "inventoryDataList": [
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 675.99999,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01374-25002",
          "cmoLotNumber": "DRCHCG01374-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01374",
          "cmoMaterialDescription": "N,N-DIMETHYLFORMAMIDE DIMETHYL ACETAL(ASSAY :90%) [4637-24-5] ( RCHCG01374 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 450.60674,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01374-25001",
          "cmoLotNumber": "DRCHCG01374-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01374",
          "cmoMaterialDescription": "N,N-DIMETHYLFORMAMIDE DIMETHYL ACETAL(ASSAY :90%) [4637-24-5] ( RCHCG01374 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 225.39325,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 72.9,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00661-25010",
          "cmoLotNumber": "DRCHCG00661-25010",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00661",
          "cmoMaterialDescription": "P-TOLUENESULFONIC ACID MONOHYDRATE,(COM) [6192-52-5] ( RCHCG00661 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 72.9,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 135.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02568-25002",
          "cmoLotNumber": "DRCHCG02568-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02568",
          "cmoMaterialDescription": "5-BROMOPHTHALIDE (COM) [64169-34-2] ( RCHCG02568 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 109.05,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02568-25001",
          "cmoLotNumber": "DRCHCG02568-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02568",
          "cmoMaterialDescription": "5-BROMOPHTHALIDE (COM) [64169-34-2] ( RCHCG02568 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 25.95,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 230.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-25023",
          "cmoLotNumber": "DRSLCG00024-25023",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 230.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 243.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25019",
          "cmoLotNumber": "DRSLCG00056-25019",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 243.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 740.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25007-02",
          "cmoLotNumber": "PDRSLCG00016-25007-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 540.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25006-17",
          "cmoLotNumber": "PDRSLCG00016-25006-17",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": "2030-05-26T00:00:00.000Z",
          "expiryDate": "2030-05-26T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 200.0,
          "cmoOnHandAvailableQuantity": 31.264,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 9.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25009",
          "cmoLotNumber": "DPPLBA00050-25009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 9.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 9.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25059",
          "cmoLotNumber": "DPCNCT00034-25059",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 9.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 9.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25013",
          "cmoLotNumber": "DPPLBA00117-25013",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 9.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1130.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00007-25002-03",
          "cmoLotNumber": "PDRSLCG00007-25002-03",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00007",
          "cmoMaterialDescription": "DICHLORO METHANE (COM) (METHYLENE CHLORIDE) [75-09-2] ( RSLCG00007 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 480.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00007-25024",
          "cmoLotNumber": "DRSLCG00007-25024",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00007",
          "cmoMaterialDescription": "DICHLORO METHANE (COM) (METHYLENE CHLORIDE) [75-09-2] ( RSLCG00007 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 650.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 333.45,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02445-25001",
          "cmoLotNumber": "DRCHCG02445-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02445",
          "cmoMaterialDescription": "BENZOPHENONE IMINE (COM) [1013-88-3] ( RCHCG02445 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 333.45,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 123.5,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSQA25001",
          "cmoLotNumber": "DBSQA25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSQA001",
          "cmoMaterialDescription": "(Z)-5-BROMO-3-((DIMETHYLAMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE (STAGE-A) ( INTBSQA001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 123.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 918.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25026",
          "cmoLotNumber": "DRSLCG00056-25026",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 918.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 756.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02769-25001",
          "cmoLotNumber": "DRCHCG02769-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02769",
          "cmoMaterialDescription": "HYDROGEN CHLORIDE SOLUTION 1.0 M IN ACETIC ACID (COM) [7647-01-0] ( RCHCG02769 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 756.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1483.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00231-25015",
          "cmoLotNumber": "DRCHCG00231-25015",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00231",
          "cmoMaterialDescription": "ALCOHOL [ETHANOL] (COM) [64-17-5] ( RCHCG00231 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 556.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00231-25019",
          "cmoLotNumber": "DRCHCG00231-25019",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00231",
          "cmoMaterialDescription": "ALCOHOL [ETHANOL] (COM) [64-17-5] ( RCHCG00231 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 927.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 546.25,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25004-04",
          "cmoLotNumber": "PDRSLCG00010-25004-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 275.46,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25004-05",
          "cmoLotNumber": "PDRSLCG00010-25004-05",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 270.79,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 24.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25012",
          "cmoLotNumber": "DPPLBA00050-25012",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 24.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 12.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25074",
          "cmoLotNumber": "DPCNCT00034-25074",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 12.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 24.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25018",
          "cmoLotNumber": "DPPLBA00117-25018",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 24.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 60.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00007-25004-01",
          "cmoLotNumber": "PDRSLCG00007-25004-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00007",
          "cmoMaterialDescription": "DICHLORO METHANE (COM) (METHYLENE CHLORIDE) [75-09-2] ( RSLCG00007 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 60.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 58.82,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00432-25001",
          "cmoLotNumber": "DRCHCG00432-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00432",
          "cmoMaterialDescription": "HYDRAZINE HYDRATE 80% (COM) [10217-52-4] ( RCHCG00432 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 58.82,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 170.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSQB25001",
          "cmoLotNumber": "DBSQB25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSQB001",
          "cmoMaterialDescription": "5-BROMO-3-(((DIPHENYLMETHYLENE)AMINO)METHYLENE)ISOBENZOFURAN-1(3H)-ONE(BMT-916213(E)+BMT-916214(Z)) (STAGE-B) ( INTBSQB001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 170.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3220.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02121725",
          "cmoLotNumber": "DPWS02121725",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 300.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02122525",
          "cmoLotNumber": "DPWS02122525",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 810.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02122625",
          "cmoLotNumber": "DPWS02122625",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 100.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02122825",
          "cmoLotNumber": "DPWS02122825",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 300.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02010226",
          "cmoLotNumber": "DPWS02010226",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 50.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02010526",
          "cmoLotNumber": "DPWS02010526",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 50.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02010626",
          "cmoLotNumber": "DPWS02010626",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 80.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02010826",
          "cmoLotNumber": "DPWS02010826",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 170.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02010926",
          "cmoLotNumber": "DPWS02010926",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 50.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02012026",
          "cmoLotNumber": "DPWS02012026",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 300.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02022426",
          "cmoLotNumber": "DPWS02022426",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 50.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02030126",
          "cmoLotNumber": "DPWS02030126",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 250.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02030226",
          "cmoLotNumber": "DPWS02030226",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 240.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02030426",
          "cmoLotNumber": "DPWS02030426",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 100.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02031326",
          "cmoLotNumber": "DPWS02031326",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 70.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02031526",
          "cmoLotNumber": "DPWS02031526",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 300.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4411.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25009-02",
          "cmoLotNumber": "PDRSLCG00016-25009-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2051.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25009-06",
          "cmoLotNumber": "PDRSLCG00016-25009-06",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2360.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 13.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25082",
          "cmoLotNumber": "DPCNCT00034-25082",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25083",
          "cmoLotNumber": "DPCNCT00034-25083",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25086",
          "cmoLotNumber": "DPCNCT00034-25086",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 5.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 7.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25013",
          "cmoLotNumber": "DPPLBA00050-25013",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 5.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25014",
          "cmoLotNumber": "DPPLBA00050-25014",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 7.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25020",
          "cmoLotNumber": "DPPLBA00117-25020",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 5.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25021",
          "cmoLotNumber": "DPPLBA00117-25021",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3268.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00368-25011",
          "cmoLotNumber": "DRCHCG00368-25011",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00368",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE (COM) [67-68-5] ( RCHCG00368 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 55.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00368-25012",
          "cmoLotNumber": "DRCHCG00368-25012",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00368",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE (COM) [67-68-5] ( RCHCG00368 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2560.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00368-26003",
          "cmoLotNumber": "DRCHCG00368-26003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00368",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE (COM) [67-68-5] ( RCHCG00368 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 635.27,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00368-26002",
          "cmoLotNumber": "DRCHCG00368-26002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00368",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE (COM) [67-68-5] ( RCHCG00368 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 17.73,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 16.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00040-25028",
          "cmoLotNumber": "DPCNCT00040-25028",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00040",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR ( PCNCT00040 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 16.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNDR00058-25043",
          "cmoLotNumber": "DPCNDR00058-25043",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNDR00058",
          "cmoMaterialDescription": "HDPE BARREL GREEN COLOUR (MODEL: NMB) (CAPACITY - 210 LTR) ( PCNDR00058 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 81.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSQC25001",
          "cmoLotNumber": "DBSQC25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSQC001",
          "cmoMaterialDescription": "4-(AMINOMETHYL)-6-BROMOPHTHALAZIN-1(2H)-ONE (MIR-006432) (STAGE-C) ( INTBSQC001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 81.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1305.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00580-25004",
          "cmoLotNumber": "DRCHCG00580-25004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00580",
          "cmoMaterialDescription": "N-METHYL PYRROLIDINONE (NMP) (COM) [872-50-4] ( RCHCG00580 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 399.68,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00580-26001",
          "cmoLotNumber": "DRCHCG00580-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00580",
          "cmoMaterialDescription": "N-METHYL PYRROLIDINONE (NMP) (COM) [872-50-4] ( RCHCG00580 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 691.73,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00580-25005",
          "cmoLotNumber": "DRCHCG00580-25005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00580",
          "cmoMaterialDescription": "N-METHYL PYRROLIDINONE (NMP) (COM) [872-50-4] ( RCHCG00580 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 213.59,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 69.98,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00554-25008",
          "cmoLotNumber": "DRCHCG00554-25008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00554",
          "cmoMaterialDescription": "N,N-DIISOPROPPYLETHYLAMINE (COM) [7087-68-5] ( RCHCG00554 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 69.98,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 0.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00780-25019",
          "cmoLotNumber": "DRCHCG00780-25019",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00780",
          "cmoMaterialDescription": "TRIETHYLAMINE (COM) [121-44-8] ( RCHCG00780 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 104.49,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00377-25006",
          "cmoLotNumber": "DRCHCG00377-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00377",
          "cmoMaterialDescription": "DITERT BUTYL DICARBONATE (COM) [24424-99-5] ( RCHCG00377 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 99.1,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00377-26001",
          "cmoLotNumber": "DRCHCG00377-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00377",
          "cmoMaterialDescription": "DITERT BUTYL DICARBONATE (COM) [24424-99-5] ( RCHCG00377 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 5.39,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 420.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25010-02",
          "cmoLotNumber": "PDRSLCG00024-25010-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 420.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1650.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25009-03",
          "cmoLotNumber": "PDRSLCG00038-25009-03",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 399.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25009-04",
          "cmoLotNumber": "PDRSLCG00038-25009-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 820.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25009-05",
          "cmoLotNumber": "PDRSLCG00038-25009-05",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 405.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-01",
          "cmoLotNumber": "PDRSLCG00038-26001-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 26.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 14.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26001",
          "cmoLotNumber": "DPPLBA00050-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 14.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 22.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26005",
          "cmoLotNumber": "DPCNCT00034-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 22.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 14.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25023",
          "cmoLotNumber": "DPPLBA00117-25023",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 14.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 280.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00555-26001",
          "cmoLotNumber": "DRCHCG00555-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00555",
          "cmoMaterialDescription": "N,N-DIMETHYL ACETAMIDE (COM) [127-19-5] ( RCHCG00555 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 280.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 80.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSQD26001",
          "cmoLotNumber": "DBSQD26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSQD001",
          "cmoMaterialDescription": "TERT-BUTYL ((7-BROMO-4-OXO-3,4-DIHYDROPHTHALAZIN-1-YL)METHYL)CARBAMATE (MIR-037058) (STAGE-D) ( INTBSQD001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 80.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 6975.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-26008",
          "cmoLotNumber": "DRSLCG00024-26008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1895.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-26010",
          "cmoLotNumber": "DRSLCG00024-26010",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1650.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-26013",
          "cmoLotNumber": "DRSLCG00024-26013",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 34.15,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-26014",
          "cmoLotNumber": "DRSLCG00024-26014",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 465.85,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-26001-02",
          "cmoLotNumber": "PDRSLCG00024-26001-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 220.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-26016",
          "cmoLotNumber": "DRSLCG00024-26016",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-26017",
          "cmoLotNumber": "DRSLCG00024-26017",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2590.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-26022",
          "cmoLotNumber": "DRSLCG00024-26022",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 90.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 984.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02829-26001",
          "cmoLotNumber": "DRCHCG02829-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02829",
          "cmoMaterialDescription": "DI-TERT-BUTYL(BUTYL)PHOSPHONIUM TETRAFLUOROBORATE (COM) [1816254-91-7] ( RCHCG02829 )",
          "cmoInventoryUOM": "gr.",
          "inventoryUOM": "gr.",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 984.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 68.8,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00279-25003",
          "cmoLotNumber": "DRCHCG00279-25003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00279",
          "cmoMaterialDescription": "BIS(PINACOLATO)DIBORON (COM) [73183-34-3] ( RCHCG00279 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.55,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00279-25004",
          "cmoLotNumber": "DRCHCG00279-25004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00279",
          "cmoMaterialDescription": "BIS(PINACOLATO)DIBORON (COM) [73183-34-3] ( RCHCG00279 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 38.25,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.44,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00554-25008",
          "cmoLotNumber": "DRCHCG00554-25008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00554",
          "cmoMaterialDescription": "N,N-DIISOPROPPYLETHYLAMINE (COM) [7087-68-5] ( RCHCG00554 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.44,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 440.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCTFR00061-26001",
          "cmoLotNumber": "DRCTFR00061-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCTFR00061",
          "cmoMaterialDescription": "PD(CROTYLCL)DIMER (COM) [12081-22-0] ( RCTFR00061 )",
          "cmoInventoryUOM": "gr.",
          "inventoryUOM": "gr.",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 440.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 47.52,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02341-26001",
          "cmoLotNumber": "DRCHCG02341-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02341",
          "cmoMaterialDescription": "POTASSIUM TRIMETHYLACETATE (COM) [19455-23-3] ( RCHCG02341 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2026-12-28T00:00:00.000Z",
          "expiryDate": "2026-12-28T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 47.52,
          "cmoOnHandAvailableQuantity": 6.256,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 7.36,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02111-25006",
          "cmoLotNumber": "DRCHCG02111-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02111",
          "cmoMaterialDescription": "AC-CYS-OH (COM) [616-91-1] ( RCHCG02111 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 7.36,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 7202.4,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25032",
          "cmoLotNumber": "DRSLCG00056-25032",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 595.82,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26004",
          "cmoLotNumber": "DRSLCG00056-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3003.38,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26005",
          "cmoLotNumber": "DRSLCG00056-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1360.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26006",
          "cmoLotNumber": "DRSLCG00056-26006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 119.2,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26007",
          "cmoLotNumber": "DRSLCG00056-26007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1164.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26008",
          "cmoLotNumber": "DRSLCG00056-26008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 960.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 58.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-26004",
          "cmoLotNumber": "DPPLBA00117-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-26005",
          "cmoLotNumber": "DPPLBA00117-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 10.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-26007",
          "cmoLotNumber": "DPPLBA00117-26007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 18.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 39.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26018",
          "cmoLotNumber": "DPCNCT00034-26018",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 15.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26022",
          "cmoLotNumber": "DPCNCT00034-26022",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 10.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26031",
          "cmoLotNumber": "DPCNCT00034-26031",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 10.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26032",
          "cmoLotNumber": "DPCNCT00034-26032",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1883.01,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-21",
          "cmoLotNumber": "PDRSLCG00038-26001-21",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 23.7,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-20",
          "cmoLotNumber": "PDRSLCG00038-26001-20",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.95,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-22",
          "cmoLotNumber": "PDRSLCG00038-26001-22",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 39.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-25",
          "cmoLotNumber": "PDRSLCG00038-26001-25",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 252.8,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-26",
          "cmoLotNumber": "PDRSLCG00038-26001-26",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 450.3,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-28",
          "cmoLotNumber": "PDRSLCG00038-26001-28",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 224.44,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-27",
          "cmoLotNumber": "PDRSLCG00038-26001-27",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2027-12-14T00:00:00.000Z",
          "expiryDate": "2027-12-14T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 41.8,
          "cmoOnHandAvailableQuantity": 4096.2,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-29",
          "cmoLotNumber": "PDRSLCG00038-26001-29",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 318.8,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26003-03",
          "cmoLotNumber": "PDRSLCG00038-26003-03",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 39.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26003-04",
          "cmoLotNumber": "PDRSLCG00038-26003-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 122.45,
          "cmoOnHandAvailableQuantity": 6220.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26003-06",
          "cmoLotNumber": "PDRSLCG00038-26003-06",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 23.7,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26003-08",
          "cmoLotNumber": "PDRSLCG00038-26003-08",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 71.1,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26003-09",
          "cmoLotNumber": "PDRSLCG00038-26003-09",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 213.3,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00038-26003",
          "cmoLotNumber": "DRSLCG00038-26003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 57.67,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 28.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26003",
          "cmoLotNumber": "DPPLBA00050-26003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 10.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26004",
          "cmoLotNumber": "DPPLBA00050-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": "2028-02-29T00:00:00.000Z",
          "expiryDate": "2028-02-29T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 10.0,
          "cmoOnHandAvailableQuantity": 6.1,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26005",
          "cmoLotNumber": "DPPLBA00050-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 100.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00007-26013",
          "cmoLotNumber": "DRSLCG00007-26013",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00007",
          "cmoMaterialDescription": "DICHLORO METHANE (COM) (METHYLENE CHLORIDE) [75-09-2] ( RSLCG00007 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 100.0,
          "cmoOnHandAvailableQuantity": 446.88,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02893-26001",
          "cmoLotNumber": "DRCHCG02893-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02893",
          "cmoMaterialDescription": "3M ZETA PLUS ACTIVATED CARBON SERIES FILTER CARTRIDGE(C16YE R55SP) (COM) ( RCHCG02893 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 26.16,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00076-26002-04",
          "cmoLotNumber": "PDRSLCG00076-26002-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00076",
          "cmoMaterialDescription": "TOLUENE (COM) [BENZENE CONTENT: 100 PPM] [108-88-3] ( RSLCG00076 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 26.16,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSQE26001",
      "materialCode": "1460388",
      "materialDescription": "BMT-811890-01",
      "materialType": "Product",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 55.07,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSQE26001",
          "cmoLotNumber": "DBSQE26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "FINBSQE001",
          "cmoMaterialDescription": "TERT-BUTYL (4-OXO-7-(4,4,5,5-TETRAMETHYL-1,3,2-DIOXABOROLAN-2-YL)-3,4-DIHYDROPHTHALAZIN-1-YL)METHYL) CARBAMATE (BMT-811890) (STAGE-E)",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 55.07,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 30.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00686-22002",
          "cmoLotNumber": "DRCHCG00686-22002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00686",
          "cmoMaterialDescription": "SODIUM BI SULPHITE (COM) [7631-90-5] ( RCHCG00686 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 36.9,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00558-25003",
          "cmoLotNumber": "DRCHCG00558-25003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00558",
          "cmoMaterialDescription": "N.BROMO SUCCINIMIDE (COM) [128-08-5] ( RCHCG00558 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 18.01,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00558-25002",
          "cmoLotNumber": "DRCHCG00558-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00558",
          "cmoMaterialDescription": "N.BROMO SUCCINIMIDE (COM) [128-08-5] ( RCHCG00558 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 18.89,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 30.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02675-25001",
          "cmoLotNumber": "DRCHCG02675-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02675",
          "cmoMaterialDescription": "4-BROMO-2-FLUOROACETOPHENONE (COM) [625446-22-2] ( RCHCG02675 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 13.14,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00661-25009",
          "cmoLotNumber": "DRCHCG00661-25009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00661",
          "cmoMaterialDescription": "P-TOLUENESULFONIC ACID MONOHYDRATE,(COM) [6192-52-5] ( RCHCG00661 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 13.14,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 340.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25017",
          "cmoLotNumber": "DRSLCG00056-25017",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 340.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25047",
          "cmoLotNumber": "DPCNCT00034-25047",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25011",
          "cmoLotNumber": "DPPLBA00117-25011",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25007",
          "cmoLotNumber": "DPPLBA00050-25007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 121.65168,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25007-04",
          "cmoLotNumber": "PDRSLCG00024-25007-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 121.65168,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 24.12,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00645-25001",
          "cmoLotNumber": "DRCHCG00645-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00645",
          "cmoMaterialDescription": "POTASSIUM IODIDE (COM) [7681-11-0] ( RCHCG00645 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.11168,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00645-21006",
          "cmoLotNumber": "DRCHCG00645-21006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00645",
          "cmoMaterialDescription": "POTASSIUM IODIDE (COM) [7681-11-0] ( RCHCG00645 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.00832,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 61.92,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00780-25013",
          "cmoLotNumber": "DRCHCG00780-25013",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00780",
          "cmoMaterialDescription": "TRIETHYLAMINE (COM) [121-44-8] ( RCHCG00780 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 61.92,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 43.56,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.605,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02676-25001",
          "cmoLotNumber": "DRCHCG02676-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02676",
          "cmoMaterialDescription": "TERT-BUTYL 4,5-DIAMINO-5-OXO-PENTANOATE HYDROCHLORIDE (COM) [1323411-16-0] ( RCHCG02676 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 43.56,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.605,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 52.92,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00554-25003",
          "cmoLotNumber": "DRCHCG00554-25003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00554",
          "cmoMaterialDescription": "N,N-DIISOPROPPYLETHYLAMINE (COM) [7087-68-5] ( RCHCG00554 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 52.92,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 36.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSRA25001",
          "cmoLotNumber": "DBSRA25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSRA001",
          "cmoMaterialDescription": "2-BROMO-1-(4-BROMO-2-FLUOROPHENYL)ETHAN-1-ONE (BMS-796258-01) (STAGE-A) ( INTBSRA001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 36.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 50.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01240-25001",
          "cmoLotNumber": "DRCHCG01240-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01240",
          "cmoMaterialDescription": "1,1 CARBONYL DI IMIDAZOLE (MC: 0.5%) [530-62-1] ( RCHCG01240 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 50.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1973.75,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00010-25005",
          "cmoLotNumber": "DRSLCG00010-25005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 342.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25003-04",
          "cmoLotNumber": "PDRSLCG00010-25003-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 74.9368,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00010-25006",
          "cmoLotNumber": "DRSLCG00010-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1556.8132,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 360.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00013-25028",
          "cmoLotNumber": "DRSLCG00013-25028",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00013",
          "cmoMaterialDescription": "ETHYL ACETATE (COM) [141-78-6] ( RSLCG00013 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.21507,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00013-25029",
          "cmoLotNumber": "DRSLCG00013-25029",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00013",
          "cmoMaterialDescription": "ETHYL ACETATE (COM) [141-78-6] ( RSLCG00013 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 351.78493,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25014",
          "cmoLotNumber": "DPPLBA00117-25014",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 5.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25064",
          "cmoLotNumber": "DPCNCT00034-25064",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 5.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 6.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPMSMS00148-25001",
          "cmoLotNumber": "DPMSMS00148-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PMSMS00148",
          "cmoMaterialDescription": "SILICA GEL 50 GMS PACK ( PMSMS00148 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 6.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.64,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01443-25004",
          "cmoLotNumber": "DRCHCG01443-25004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01443",
          "cmoMaterialDescription": "BIS (TRIPHENYLPHOSPHINE) PALLADIUM (II) CHLORIDE {COM} [13965-03-2] ( RCHCG01443 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.005,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01443-25006",
          "cmoLotNumber": "DRCHCG01443-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01443",
          "cmoMaterialDescription": "BIS (TRIPHENYLPHOSPHINE) PALLADIUM (II) CHLORIDE {COM} [13965-03-2] ( RCHCG01443 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.635,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1054.99998,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00037-25004",
          "cmoLotNumber": "DRCHCG00037-25004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00037",
          "cmoMaterialDescription": "1,2-DIMETHOXY ETHANE [MONOGLYME] (COM) [110-71-4] ( RCHCG00037 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 824.99999,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00037-25003",
          "cmoLotNumber": "DRCHCG00037-25003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00037",
          "cmoMaterialDescription": "1,2-DIMETHOXY ETHANE [MONOGLYME] (COM) [110-71-4] ( RCHCG00037 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 229.99999,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 26.07,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02341-25001",
          "cmoLotNumber": "DRCHCG02341-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02341",
          "cmoMaterialDescription": "POTASSIUM TRIMETHYLACETATE (COM) [19455-23-3] ( RCHCG02341 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 26.07,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 20.13,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.053,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02632-25001",
          "cmoLotNumber": "DRCHCG02632-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02632",
          "cmoMaterialDescription": "BIS(NEOPENTYL GLYCOLATO)DIBORON (COM) [201733-56-4] ( RCHCG02632 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2026-08-18T00:00:00.000Z",
          "expiryDate": "2026-08-18T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.13,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.053,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 33.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSRB25001",
          "cmoLotNumber": "DBSRB25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSRB001",
          "cmoMaterialDescription": "TERT-BUTYL 5-AMINO-4-(5-(4-BROMO-2-FLUOROPHENYL)-2-OXOOXAZOL-3(2H)-YL)-5-OXOPENTANOATE(BMT-813536-01) (STAGE-B) ( INTBSRB001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 33.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25010",
          "cmoLotNumber": "DPPLBA00050-25010",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 10.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25066",
          "cmoLotNumber": "DPCNCT00034-25066",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 10.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25015",
          "cmoLotNumber": "DPPLBA00117-25015",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1320.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25008-03",
          "cmoLotNumber": "PDRSLCG00016-25008-03",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 50.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25006-14",
          "cmoLotNumber": "PDRSLCG00016-25006-14",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 853.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25006-15",
          "cmoLotNumber": "PDRSLCG00016-25006-15",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 417.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 270.75,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00010-25009",
          "cmoLotNumber": "DRSLCG00010-25009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 242.25,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25004-04",
          "cmoLotNumber": "PDRSLCG00010-25004-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 28.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 162.36,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00693-25024",
          "cmoLotNumber": "DRCHCG00693-25024",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00693",
          "cmoMaterialDescription": "SODIUM CHLORIDE (COM) [7647-14-5] ( RCHCG00693 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 162.36,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 0.157,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCTFR00029-25002",
          "cmoLotNumber": "DRCTFR00029-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCTFR00029",
          "cmoMaterialDescription": "PALLADIUM(II) ACETATE (PALLADIUMACETATE) (COM) [3375-31-3] ( RCTFR00029 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2027-08-20T00:00:00.000Z",
          "expiryDate": "2027-08-20T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.157,
          "cmoOnHandAvailableQuantity": 0.174,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 30.12,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00657-25008",
          "cmoLotNumber": "DRCHCG00657-25008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00657",
          "cmoMaterialDescription": "POTTASIUM PHOSPHATE TRIBASIC (COM) [7778-53-2] ( RCHCG00657 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.12,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 6.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRGSGA00008-25094",
          "cmoLotNumber": "DRGSGA00008-25094",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RGSGA00008",
          "cmoMaterialDescription": "NITROGEN GAS CYLINDER (COM) [7727-37-9] ( RGSGA00008 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 6.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 23.42,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSRC25001",
          "cmoLotNumber": "DBSRC25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSRC001",
          "cmoMaterialDescription": "TERT-BUTYL 5-AMINO-4-(5-(4-(5,5-DIMETHYL-1,3,2- DIOXABORINAN-2-YL)-2-FLUOROPHENYL)-2-OXOOXAZOL- 3(2H)-YL)-5-OXOPENTANOATE (BMT-854872-01) (STAGE-C) ( INTBSRC001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 23.42,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 21.31,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02633-25001",
          "cmoLotNumber": "DRCHCG02633-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02633",
          "cmoMaterialDescription": "DL-TARTARIC ACID (COM) [133-37-9] ( RCHCG02633 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 21.31,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 0.812,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00113-25001",
          "cmoLotNumber": "DRCHCG00113-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00113",
          "cmoMaterialDescription": "2-DICYCLOHEXYLPHOSPHINO-2',4',6'-TRIISOPROPYL BI PHENYL (X-POS) (COM) [564483-18-7] ( RCHCG00113 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2027-03-19T00:00:00.000Z",
          "expiryDate": "2027-03-19T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.812,
          "cmoOnHandAvailableQuantity": 0.538,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 22.55,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02449-25001",
          "cmoLotNumber": "DRCHCG02449-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02449",
          "cmoMaterialDescription": "SILICYCLE® SILIAMETS® METAL SCAVENGERS THIOL (SH), 40-63 μm, 60 Å (COM) [2222807-05-6] ( RCHCG02449 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 22.55,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1121.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-ST25003",
          "cmoLotNumber": "DRSLCG00024-ST25003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 902.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-25026",
          "cmoLotNumber": "DRSLCG00024-25026",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 219.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 7.396,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02631-25002",
          "cmoLotNumber": "DRCHCG02631-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02631",
          "cmoMaterialDescription": "6-CHLORO-3,4-DIMETHYL-2-PYRIDINAMINE (COM) [1503408-77-2] ( RCHCG02631 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 7.396,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1036.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS01101325",
          "cmoLotNumber": "DPWS01101325",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 73.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS01101425",
          "cmoLotNumber": "DPWS01101425",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 542.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS01101525",
          "cmoLotNumber": "DPWS01101525",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 421.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 7.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25069",
          "cmoLotNumber": "DPCNCT00034-25069",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 7.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 9.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25016",
          "cmoLotNumber": "DPPLBA00117-25016",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 9.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 769.5,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00010-25008",
          "cmoLotNumber": "DRSLCG00010-25008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 604.76999,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00010-25009",
          "cmoLotNumber": "DRSLCG00010-25009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 145.73001,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25004-05",
          "cmoLotNumber": "PDRSLCG00010-25004-05",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 19.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 6.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25011",
          "cmoLotNumber": "DPPLBA00050-25011",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 6.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 5.688,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02667-25001",
          "cmoLotNumber": "DRCHCG02667-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02667",
          "cmoMaterialDescription": "POTASSIUM PHOSPHATE DIBASIC (ANHYDROUS) 98% EXTRA PURE (COM) [7758-11-4] ( RCHCG02667 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 5.688,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 6.358,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DINTBSRD001-25001",
          "cmoLotNumber": "DINTBSRD001-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSRD001",
          "cmoMaterialDescription": "TERT-BUTYL 5-AMINO-4-(5-(4-(6-AMINO-4,5-DIMETHYLPYRIDIN-2-YL)-2-FLUOROPHENYL)-2-OXOOXAZOL-3(2H)-YL)-5-OXOPENTANOATE TARTARATE (BMT-854873-01) (STAGE-D) ( INTBSRD001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 6.358,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 6.58,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 5.65,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01347-25001",
          "cmoLotNumber": "DRCHCG01347-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01347",
          "cmoMaterialDescription": "TRIFLUOROMETHANESULFONIC ACID [EM] [1493-13-6] ( RCHCG01347 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2026-04-30T00:00:00.000Z",
          "expiryDate": "2026-04-30T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 6.58,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 5.65,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 630.63936,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25014",
          "cmoLotNumber": "DRSLCG00056-25014",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 277.6,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25012",
          "cmoLotNumber": "DRSLCG00056-25012",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 328.23936,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25013",
          "cmoLotNumber": "DRSLCG00056-25013",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 9.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25016",
          "cmoLotNumber": "DRSLCG00056-25016",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 15.8,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPMSMS00148-25001",
          "cmoLotNumber": "DPMSMS00148-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PMSMS00148",
          "cmoMaterialDescription": "SILICA GEL 50 GMS PACK ( PMSMS00148 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 20.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00113-25001",
          "cmoLotNumber": "DPPLBA00113-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00113",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS. CAPACITY : 25 KG. SIZE : 18\" X 30\" ( PPLBA00113 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 20.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25009",
          "cmoLotNumber": "DPPLBA00117-25009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 20.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00048-23001",
          "cmoLotNumber": "DPPLBA00048-23001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00048",
          "cmoMaterialDescription": "BLACK POLYTHENE BAG (18” X 30” X 400 GAUGE) ( PPLBA00048 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 20.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25006",
          "cmoLotNumber": "DPPLBA00050-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 6.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00033-24001",
          "cmoLotNumber": "DPCNCT00033-24001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00033",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 30 Ltr Cap. ( PCNCT00033 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 6.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25039",
          "cmoLotNumber": "DPCNCT00034-25039",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 533.5,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25002-04",
          "cmoLotNumber": "PDRSLCG00010-25002-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 132.6,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25001-01",
          "cmoLotNumber": "PDRSLCG00010-25001-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 5.7,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25003-01",
          "cmoLotNumber": "PDRSLCG00010-25003-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 175.75,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25003-03",
          "cmoLotNumber": "PDRSLCG00010-25003-03",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 219.45,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSRE25001",
      "materialCode": "1453915",
      "materialDescription": "BMS-986482-02",
      "materialType": "Product",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 0.047,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DFINBSRE001-25001",
          "cmoLotNumber": "DFINBSRE001-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "FINBSRE001",
          "cmoMaterialDescription": "3-(5-(4-(6-AMINO-4,5-DIMETHYLPYRIDIN-2-YL)-2-FLUOROPHENYL)-2-OXOOXAZOL-3(2H)-YL)PIPERIDINE-2,6-DIONE (BMS-986482-02) (STAGE-E) ( FINBSRE001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.047,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4934.60004,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25006",
          "cmoLotNumber": "DRCHCG00124-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2374.92458,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25007",
          "cmoLotNumber": "DRCHCG00124-25007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2559.67546,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 100.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02736-25001",
          "cmoLotNumber": "DRCHCG02736-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02736",
          "cmoMaterialDescription": "2,5-DIFLUORO-4-CHLOROBENZOIC ACID (COM) [132794-07-1] ( RCHCG02736 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 100.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1000.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DINTBSZA001-25001",
          "cmoLotNumber": "DINTBSZA001-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSZA001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-IODOBENZAMIDE (BMT-901423) (STAGE-A) ( INTBSZA001 )",
          "cmoInventoryUOM": "gr.",
          "inventoryUOM": "gr.",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1000.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 127.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01240-25004",
          "cmoLotNumber": "DRCHCG01240-25004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01240",
          "cmoMaterialDescription": "1,1 CARBONYL DI IMIDAZOLE (MC: 0.5%) [530-62-1] ( RCHCG01240 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 119.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01240-25005",
          "cmoLotNumber": "DRCHCG01240-25005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01240",
          "cmoMaterialDescription": "1,1 CARBONYL DI IMIDAZOLE (MC: 0.5%) [530-62-1] ( RCHCG01240 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 200.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00693-25027",
          "cmoLotNumber": "DRCHCG00693-25027",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00693",
          "cmoMaterialDescription": "SODIUM CHLORIDE (COM) [7647-14-5] ( RCHCG00693 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 200.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 100.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00686-22002",
          "cmoLotNumber": "DRCHCG00686-22002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00686",
          "cmoMaterialDescription": "SODIUM BI SULPHITE (COM) [7631-90-5] ( RCHCG00686 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 100.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 291.99999,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00247-25008",
          "cmoLotNumber": "DRCHCG00247-25008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00247",
          "cmoMaterialDescription": "AMMONIA SOLUTION, 25% (COM) [1336-21-6] ( RCHCG00247 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 291.99999,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 198.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00454-25001",
          "cmoLotNumber": "DRCHCG00454-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00454",
          "cmoMaterialDescription": "IODINE (COM) [7553-56-2] ( RCHCG00454 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 56.8709,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00454-25002",
          "cmoLotNumber": "DRCHCG00454-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00454",
          "cmoMaterialDescription": "IODINE (COM) [7553-56-2] ( RCHCG00454 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 141.1291,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1090.62498,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02737-25001",
          "cmoLotNumber": "DRCHCG02737-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02737",
          "cmoMaterialDescription": "2 2 6 6-TETRAMETHYL PIPERIDINYL MAGNESIUM CHLORIDE LITHIUM CHLORIDE (1.0 M IN THF) (COM) [898838-07-8] ( RCHCG02737 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1090.62498,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 280.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00435-25022",
          "cmoLotNumber": "DRCHCG00435-25022",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00435",
          "cmoMaterialDescription": "HYDROCHLORIC ACID - CP (COM) [7647-01-0] ( RCHCG00435 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 280.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 20.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25076",
          "cmoLotNumber": "DPCNCT00034-25076",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 20.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25018",
          "cmoLotNumber": "DPPLBA00117-25018",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1801.2,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-04",
          "cmoLotNumber": "PDRSLCG00038-25007-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 229.1,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25008-01",
          "cmoLotNumber": "PDRSLCG00038-25008-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 165.9,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-05",
          "cmoLotNumber": "PDRSLCG00038-25007-05",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 341.51385,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-06",
          "cmoLotNumber": "PDRSLCG00038-25007-06",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1033.08615,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-07",
          "cmoLotNumber": "PDRSLCG00038-25007-07",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 31.6,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 10.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00040-25025",
          "cmoLotNumber": "DPCNCT00040-25025",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00040",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR ( PCNCT00040 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 7.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00040-25026",
          "cmoLotNumber": "DPCNCT00040-25026",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00040",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR ( PCNCT00040 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 560.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-25027",
          "cmoLotNumber": "DRSLCG00024-25027",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 510.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25010-02",
          "cmoLotNumber": "PDRSLCG00024-25010-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 50.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1989.99998,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25009-01",
          "cmoLotNumber": "PDRSLCG00016-25009-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1989.99998,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 450.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00021-25020",
          "cmoLotNumber": "DRSLCG00021-25020",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00021",
          "cmoMaterialDescription": "N-HEPTANE (COM) [142-82-5] ( RSLCG00021 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 450.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 10.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25013",
          "cmoLotNumber": "DPPLBA00050-25013",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 10.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 120.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSZA25001",
          "cmoLotNumber": "DBSZA25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSZA001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-IODOBENZAMIDE (BMT-901423) (STAGE-A) ( INTBSZA001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 119.875,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DINTBSZA001-25001",
          "cmoLotNumber": "DINTBSZA001-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSZA001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-IODOBENZAMIDE (BMT-901423) (STAGE-A) ( INTBSZA001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.125,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 148.6,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00780-25018",
          "cmoLotNumber": "DRCHCG00780-25018",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00780",
          "cmoMaterialDescription": "TRIETHYLAMINE (COM) [121-44-8] ( RCHCG00780 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 148.6,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 110.6,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01026-25001",
          "cmoLotNumber": "DRCHCG01026-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01026",
          "cmoMaterialDescription": "TRIFLUOROACETIC ANHYDRIDE (CG) [407-25-0] ( RCHCG01026 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2027-10-27T00:00:00.000Z",
          "expiryDate": "2027-10-27T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 110.6,
          "cmoOnHandAvailableQuantity": 67.362,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 894.99998,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25007-07",
          "cmoLotNumber": "PDRSLCG00024-25007-07",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.97075,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25007-08",
          "cmoLotNumber": "PDRSLCG00024-25007-08",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 761.02924,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25007-09",
          "cmoLotNumber": "PDRSLCG00024-25007-09",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 34.91456,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25007-10",
          "cmoLotNumber": "PDRSLCG00024-25007-10",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 95.08543,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1439.99999,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25009-02",
          "cmoLotNumber": "PDRSLCG00016-25009-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1190.52578,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00016-25009-03",
          "cmoLotNumber": "PDRSLCG00016-25009-03",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00016",
          "cmoMaterialDescription": "ISO PROPYL ALCOHOL [2-PROPANOL] (COM) [67-63-0] ( RSLCG00016 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 249.47421,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 12.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25013",
          "cmoLotNumber": "DPPLBA00050-25013",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 12.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25082",
          "cmoLotNumber": "DPCNCT00034-25082",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 12.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25020",
          "cmoLotNumber": "DPPLBA00117-25020",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 12.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1117.85,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-10",
          "cmoLotNumber": "PDRSLCG00038-25007-10",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 455.75,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-13",
          "cmoLotNumber": "PDRSLCG00038-25007-13",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 342.15,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25006-13",
          "cmoLotNumber": "PDRSLCG00038-25006-13",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 319.95,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00084-25043",
          "cmoLotNumber": "DPCNCT00084-25043",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00084",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS ( PCNCT00084 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 68.283,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01542-25001",
          "cmoLotNumber": "DRCHCG01542-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01542",
          "cmoMaterialDescription": "1-METHYL-1H-PYRAZOL-5-BORONIC ACID PINACOL ESTER (COM) (847818-74-0) ( RCHCG01542 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 68.283,
          "cmoOnHandAvailableQuantity": 41.61,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.103,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02658-25002",
          "cmoLotNumber": "DRCHCG02658-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02658",
          "cmoMaterialDescription": "DICHLORO[9,9-DIMETHYL-4,5-BIS(DIPHENYLPHOSPHINO)XANTHENE]PALLADIUM(II) (COM) [205319-10-4] ( RCHCG02658 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2027-09-27T00:00:00.000Z",
          "expiryDate": "2027-09-27T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.103,
          "cmoOnHandAvailableQuantity": 12.464,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 126.15,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02739-25001",
          "cmoLotNumber": "DRCHCG02739-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02739",
          "cmoMaterialDescription": "TETRAMETHYL AMMONIUM HYDROGEN CARBONATE (COM) [58345-96-3] ( RCHCG02739 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 126.15,
          "cmoOnHandAvailableQuantity": 781.242,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 96.12,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSZB25001",
          "cmoLotNumber": "DBSZB25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSZB001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-IODOBENZONITRILE (BMT-901424) (STAGE-B) ( INTBSZB001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 96.12,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 57.197,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00780-25019",
          "cmoLotNumber": "DRCHCG00780-25019",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00780",
          "cmoMaterialDescription": "TRIETHYLAMINE (COM) [121-44-8] ( RCHCG00780 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 57.197,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3202.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00076-25062",
          "cmoLotNumber": "DRSLCG00076-25062",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00076",
          "cmoMaterialDescription": "TOLUENE (COM) [BENZENE CONTENT: 100 PPM] [108-88-3] ( RSLCG00076 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 259.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00076-26008",
          "cmoLotNumber": "DRSLCG00076-26008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00076",
          "cmoMaterialDescription": "TOLUENE (COM) [BENZENE CONTENT: 100 PPM] [108-88-3] ( RSLCG00076 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 619.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00076-26003",
          "cmoLotNumber": "DRSLCG00076-26003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00076",
          "cmoMaterialDescription": "TOLUENE (COM) [BENZENE CONTENT: 100 PPM] [108-88-3] ( RSLCG00076 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 210.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00076-26009",
          "cmoLotNumber": "DRSLCG00076-26009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00076",
          "cmoMaterialDescription": "TOLUENE (COM) [BENZENE CONTENT: 100 PPM] [108-88-3] ( RSLCG00076 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2114.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 10.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26007",
          "cmoLotNumber": "DPCNCT00034-26007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26009",
          "cmoLotNumber": "DPCNCT00034-26009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 14.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00084-26004",
          "cmoLotNumber": "DPCNCT00084-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00084",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS ( PCNCT00084 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 12.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00084-26005",
          "cmoLotNumber": "DPCNCT00084-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00084",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS ( PCNCT00084 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 6.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00040-26002",
          "cmoLotNumber": "DPCNCT00040-26002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00040",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR ( PCNCT00040 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 6.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 151.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00435-26001",
          "cmoLotNumber": "DRCHCG00435-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00435",
          "cmoMaterialDescription": "HYDROCHLORIC ACID - CP (COM) [7647-01-0] ( RCHCG00435 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 151.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1467.82,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25008-04",
          "cmoLotNumber": "PDRSLCG00038-25008-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 161.95,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25008-07",
          "cmoLotNumber": "PDRSLCG00038-25008-07",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 292.3,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00038-ST26001",
          "cmoLotNumber": "DRSLCG00038-ST26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 63.2,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-06",
          "cmoLotNumber": "PDRSLCG00038-26001-06",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 79.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-07",
          "cmoLotNumber": "PDRSLCG00038-26001-07",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 622.52,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-09",
          "cmoLotNumber": "PDRSLCG00038-26001-09",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 55.3,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-10",
          "cmoLotNumber": "PDRSLCG00038-26001-10",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 193.55,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00299-25008",
          "cmoLotNumber": "DRCHCG00299-25008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00299",
          "cmoMaterialDescription": "CELITE (HYFLOW) (COM) ( RCHCG00299 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 0.841,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DINTBSZC001-26001",
          "cmoLotNumber": "DINTBSZC001-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSZC001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-(1-METHYL-1H-PYRAZOL-5-YL)BENZONITRILE (BMT-901425) (STAGE-C) ( INTBSZC001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.841,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 925.99999,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00021-25008-01",
          "cmoLotNumber": "PDRSLCG00021-25008-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00021",
          "cmoMaterialDescription": "N-HEPTANE (COM) [142-82-5] ( RSLCG00021 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 252.34948,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00021-26002",
          "cmoLotNumber": "DRSLCG00021-26002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00021",
          "cmoMaterialDescription": "N-HEPTANE (COM) [142-82-5] ( RSLCG00021 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 673.65051,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-26001",
          "cmoLotNumber": "DPPLBA00117-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26001",
          "cmoLotNumber": "DPPLBA00050-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZC26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 80.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02021526",
          "cmoLotNumber": "DPWS02021526",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS01062826",
          "cmoLotNumber": "DPWS01062826",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 50.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 8.8,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02111-25006",
          "cmoLotNumber": "DRCHCG02111-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02111",
          "cmoMaterialDescription": "AC-CYS-OH (COM) [616-91-1] ( RCHCG02111 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.8,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 55.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSZC26001",
          "cmoLotNumber": "DBSZC26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSZC001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-(1-METHYL-1H-PYRAZOL-5-YL)BENZONITRILE (BMT-901425) (STAGE-C) ( INTBSZC001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 54.846,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DINTBSZC001-26001",
          "cmoLotNumber": "DINTBSZC001-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSZC001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-(1-METHYL-1H-PYRAZOL-5-YL)BENZONITRILE (BMT-901425) (STAGE-C) ( INTBSZC001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.154,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 12.32,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00784-25007",
          "cmoLotNumber": "DRCHCG00784-25007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00784",
          "cmoMaterialDescription": "TRIFLUORO ACETIC ACID (COM) [76-05-1] ( RCHCG00784 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 12.32,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 11.55,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00657-26001",
          "cmoLotNumber": "DRCHCG00657-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00657",
          "cmoMaterialDescription": "POTTASIUM PHOSPHATE TRIBASIC (COM) [7778-53-2] ( RCHCG00657 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 11.55,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 54.92,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00573-25001",
          "cmoLotNumber": "DRCHCG00573-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00573",
          "cmoMaterialDescription": "N-IODO SUCCINIMIDE (COM) [516-12-1] ( RCHCG00573 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 54.92,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 5.17,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00726-26004",
          "cmoLotNumber": "DRCHCG00726-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00726",
          "cmoMaterialDescription": "SODIUMHYDROXIDE FLAKES (COM) [1310-73-2] ( RCHCG00726 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 5.17,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 27.5,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00716-25003",
          "cmoLotNumber": "DRCHCG00716-25003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00716",
          "cmoMaterialDescription": "SODIUM SULFITE (COM) [7757-83-7] ( RCHCG00716 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 27.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 340.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25032",
          "cmoLotNumber": "DRSLCG00056-25032",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 36.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26002",
          "cmoLotNumber": "DRSLCG00056-26002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": "2030-12-31T00:00:00.000Z",
          "expiryDate": "2030-12-31T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 200.0,
          "cmoOnHandAvailableQuantity": 335.9,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26003",
          "cmoLotNumber": "DRSLCG00056-26003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 104.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 7.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00040-26005",
          "cmoLotNumber": "DPCNCT00040-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00040",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR ( PCNCT00040 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 7.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 595.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-26003",
          "cmoLotNumber": "DRSLCG00018-26003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 99.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-26004",
          "cmoLotNumber": "DRSLCG00018-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 466.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-26005",
          "cmoLotNumber": "DRSLCG00018-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02793-D25009",
          "cmoLotNumber": "DRCHCG02793-D25009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02793",
          "cmoMaterialDescription": "3M ZETA PLUS ACTIVATED CARBON SERIES FILTER CARTRIDGE C16MA R55SP ( RCHCG02793 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02793-25001",
          "cmoLotNumber": "DRCHCG02793-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02793",
          "cmoMaterialDescription": "3M ZETA PLUS ACTIVATED CARBON SERIES FILTER CARTRIDGE C16MA R55SP ( RCHCG02793 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3018.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00231-26001",
          "cmoLotNumber": "DRCHCG00231-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00231",
          "cmoMaterialDescription": "ALCOHOL [ETHANOL] (COM) [64-17-5] ( RCHCG00231 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3018.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 645.43,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-13",
          "cmoLotNumber": "PDRSLCG00038-26001-13",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 67.94,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-14",
          "cmoLotNumber": "PDRSLCG00038-26001-14",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 28.44,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-16",
          "cmoLotNumber": "PDRSLCG00038-26001-16",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 47.4,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-17",
          "cmoLotNumber": "PDRSLCG00038-26001-17",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 296.25,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-22",
          "cmoLotNumber": "PDRSLCG00038-26001-22",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 158.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-23",
          "cmoLotNumber": "PDRSLCG00038-26001-23",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 47.4,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 0.55,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "",
          "cmoLotNumber": "",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "FINBSZD001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-(4-IODO-1-METHYL-1H-PYRAZOL-5-YL)BENZONITRILE (BMT-897624) (STAGE-D) ( FINBSZD001 )",
          "cmoInventoryUOM": "",
          "inventoryUOM": "",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": null,
          "cmoOnHandAvailableQuantity": null,
          "netAvailableQuantity": null,
          "committedQuantity": null,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DFINBSZD001-26001",
          "cmoLotNumber": "DFINBSZD001-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "FINBSZD001",
          "cmoMaterialDescription": "4-CHLORO-3,6-DIFLUORO-2-(4-IODO-1-METHYL-1H-PYRAZOL-5-YL)BENZONITRILE (BMT-897624) (STAGE-D) ( FINBSZD001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.55,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 15.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26016",
          "cmoLotNumber": "DPCNCT00034-26016",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26018",
          "cmoLotNumber": "DPCNCT00034-26018",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26019",
          "cmoLotNumber": "DPCNCT00034-26019",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 9.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 33.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26002",
          "cmoLotNumber": "DPPLBA00050-26002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26003",
          "cmoLotNumber": "DPPLBA00050-26003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 13.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSZD26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 63.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-26004",
          "cmoLotNumber": "DPPLBA00117-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 40.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-26005",
          "cmoLotNumber": "DPPLBA00117-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 23.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 12.852,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 33.882,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02657-25001",
          "cmoLotNumber": "DRCHCG02657-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02657",
          "cmoMaterialDescription": "(6S)-6-METHYL-1,4-OXAZEPAN-6-OL;HYDROCHLORIDE (COM) [2832734-19-5] ( RCHCG02657 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2026-03-19T00:00:00.000Z",
          "expiryDate": "2026-03-19T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 12.852,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 33.882,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 17.7,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02644-25001",
          "cmoLotNumber": "DRCHCG02644-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02644",
          "cmoMaterialDescription": "2,4,7-TRICHLORO-8-FLUORO-PYRIDO[4,3-D]PYRIMIDINE (COM) [2454396-80-4] ( RCHCG02644 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 17.7,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 18.762,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00083-25001",
          "cmoLotNumber": "DRCHCG00083-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00083",
          "cmoMaterialDescription": "2,6-LUTIDINE (COM) [108-48-5] ( RCHCG00083 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 18.762,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 305.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25017",
          "cmoLotNumber": "DRSLCG00056-25017",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 305.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25007",
          "cmoLotNumber": "DPPLBA00050-25007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25046",
          "cmoLotNumber": "DPCNCT00034-25046",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25011",
          "cmoLotNumber": "DPPLBA00117-25011",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTA25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 125.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25006-05",
          "cmoLotNumber": "PDRSLCG00024-25006-05",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 125.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2681.06003,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25004",
          "cmoLotNumber": "DRCHCG00124-25004",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1842.68089,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25003",
          "cmoLotNumber": "DRCHCG00124-25003",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 270.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25005",
          "cmoLotNumber": "DRCHCG00124-25005",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 568.37914,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 57.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 24.37,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02652-25001",
          "cmoLotNumber": "DRCHCG02652-25001",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG02652",
          "cmoMaterialDescription": "[(4aS,7aR)-1,2,3,4,5,6,7,7a-OCTAHYDROCYCLOPENTA[b]PYRIDIN-4a-YL]METHANOL HYDROCHLORIDE (COM) [2940879-31-0] ( RCHCG02652 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 57.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 24.37,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 141.47,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01162-25001",
          "cmoLotNumber": "DRCHCG01162-25001",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG01162",
          "cmoMaterialDescription": "TERT-BUTYLDIMETHYLSILYL TRIFLUOROMETHANESULFONATE (COM) [69739-34-0] ( RCHCG01162 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 141.47,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 175.81,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00726-25023",
          "cmoLotNumber": "DRCHCG00726-25023",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00726",
          "cmoMaterialDescription": "SODIUMHYDROXIDE FLAKES (COM) [1310-73-2] ( RCHCG00726 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 134.093,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00726-25024",
          "cmoLotNumber": "DRCHCG00726-25024",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00726",
          "cmoMaterialDescription": "SODIUMHYDROXIDE FLAKES (COM) [1310-73-2] ( RCHCG00726 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 41.717,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 63.73,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00083-25002",
          "cmoLotNumber": "DRCHCG00083-25002",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00083",
          "cmoMaterialDescription": "2,6-LUTIDINE (COM) [108-48-5] ( RCHCG00083 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 63.73,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 85.5,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02423-25001",
          "cmoLotNumber": "DRCHCG02423-25001",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG02423",
          "cmoMaterialDescription": "DI SODIUM HYDROGEN CITRATE (COM) [144-33-2] ( RCHCG02423 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 85.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 8209.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02092025",
          "cmoLotNumber": "DPWS02092025",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 620.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02092125",
          "cmoLotNumber": "DPWS02092125",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2010.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02092225",
          "cmoLotNumber": "DPWS02092225",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 100.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02092725",
          "cmoLotNumber": "DPWS02092725",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1191.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02092825",
          "cmoLotNumber": "DPWS02092825",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 861.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02092925",
          "cmoLotNumber": "DPWS02092925",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1061.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02093025",
          "cmoLotNumber": "DPWS02093025",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1185.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02100125",
          "cmoLotNumber": "DPWS02100125",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 941.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPWS02100225",
          "cmoLotNumber": "DPWS02100225",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PR",
          "cmoMaterialDescription": "Process Water ( PR )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 240.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 16.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNDR00058-25034",
          "cmoLotNumber": "DPCNDR00058-25034",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PCNDR00058",
          "cmoMaterialDescription": "HDPE BARREL GREEN COLOUR (MODEL: NMB) (CAPACITY - 210 LTR) ( PCNDR00058 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNDR00058-25035",
          "cmoLotNumber": "DPCNDR00058-25035",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PCNDR00058",
          "cmoMaterialDescription": "HDPE BARREL GREEN COLOUR (MODEL: NMB) (CAPACITY - 210 LTR) ( PCNDR00058 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 713.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25002-04",
          "cmoLotNumber": "PDRSLCG00010-25002-04",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 30.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00010-25007",
          "cmoLotNumber": "DRSLCG00010-25007",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 663.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00010-25003-01",
          "cmoLotNumber": "PDRSLCG00010-25003-01",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 20.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00084-25035",
          "cmoLotNumber": "DPCNCT00084-25035",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PCNCT00084",
          "cmoMaterialDescription": "GI DRUM 200 TO 210 LTRS ( PCNCT00084 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 136.86,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00722-25005",
          "cmoLotNumber": "DRCHCG00722-25005",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00722",
          "cmoMaterialDescription": "SODIUM TRIACETOXY BOROHYDRIDE (COM) [56553-60-7] ( RCHCG00722 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 136.86,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 151.99999,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00368-25010",
          "cmoLotNumber": "DRCHCG00368-25010",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00368",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE (COM) [67-68-5] ( RCHCG00368 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 151.99818,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00368-25009",
          "cmoLotNumber": "DRCHCG00368-25009",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00368",
          "cmoMaterialDescription": "DIMETHYL SULFOXIDE (COM) [67-68-5] ( RCHCG00368 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.00181,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 76.04999,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00439-25006",
          "cmoLotNumber": "DRCHCG00439-25006",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00439",
          "cmoMaterialDescription": "HYDROCHLORIC ACID, 5.5 MOLARSOLUTION IN ISO PROPYL ALCOHOL (COM) ( RCHCG00439 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 76.04999,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 104.95,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00599-25002",
          "cmoLotNumber": "DRCHCG00599-25002",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00599",
          "cmoMaterialDescription": "ORTHO PHOSPHORIC ACID (COM) [7664-38-2] ( RCHCG00599 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 104.95,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 170.66,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00643-25017",
          "cmoLotNumber": "DRCHCG00643-25017",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00643",
          "cmoMaterialDescription": "POTASSIUM HYDROXIDE FLACKS (COM) [1310-58-3] ( RCHCG00643 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 151.22,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00643-25016",
          "cmoLotNumber": "DRCHCG00643-25016",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00643",
          "cmoMaterialDescription": "POTASSIUM HYDROXIDE FLACKS (COM) [1310-58-3] ( RCHCG00643 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 19.44,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 91.26,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00693-25022",
          "cmoLotNumber": "DRCHCG00693-25022",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG00693",
          "cmoMaterialDescription": "SODIUM CHLORIDE (COM) [7647-14-5] ( RCHCG00693 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 91.26,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 45.4,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02059-25003",
          "cmoLotNumber": "DRCHCG02059-25003",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG02059",
          "cmoMaterialDescription": "L-MALIC ACID (COM) [97-67-6] ( RCHCG02059 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 45.4,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 72.32,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02649-25001",
          "cmoLotNumber": "DRCHCG02649-25001",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RCHCG02649",
          "cmoMaterialDescription": "CIS-2,6-DIMETHYLOXAN-4-ONE (COM) [14505-80-7] ( RCHCG02649 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 72.32,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4340.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-25080",
          "cmoLotNumber": "DRSLCG00018-25080",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1608.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-25075",
          "cmoLotNumber": "DRSLCG00018-25075",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1416.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-25079",
          "cmoLotNumber": "DRSLCG00018-25079",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 582.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-25076",
          "cmoLotNumber": "DRSLCG00018-25076",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 582.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-25081",
          "cmoLotNumber": "DRSLCG00018-25081",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": "2030-09-17T00:00:00.000Z",
          "expiryDate": "2030-09-17T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 152.0,
          "cmoOnHandAvailableQuantity": 463.008,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 12.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25067",
          "cmoLotNumber": "DPCNCT00034-25067",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 12.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 25.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25015",
          "cmoLotNumber": "DPPLBA00117-25015",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 25.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRGSGA00008-25091",
          "cmoLotNumber": "DRGSGA00008-25091",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RGSGA00008",
          "cmoMaterialDescription": "NITROGEN GAS CYLINDER (COM) [7727-37-9] ( RGSGA00008 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 679.4,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25005-17",
          "cmoLotNumber": "PDRSLCG00038-25005-17",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 576.7,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25005-15",
          "cmoLotNumber": "PDRSLCG00038-25005-15",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 23.7,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25006-07",
          "cmoLotNumber": "PDRSLCG00038-25006-07",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 79.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 15.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25010",
          "cmoLotNumber": "DPPLBA00050-25010",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 15.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
      "storageLocationID": "DBSUB25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 16.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPMSMS00148-25001",
          "cmoLotNumber": "DPMSMS00148-25001",
          "vendorName": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "vendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV (BSU side-chain)",
          "cmoMaterialCode": "PMSMS00148",
          "cmoMaterialDescription": "SILICA GEL 50 GMS PACK ( PMSMS00148 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 16.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 26.29,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00083-25002",
          "cmoLotNumber": "DRCHCG00083-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00083",
          "cmoMaterialDescription": "2,6-LUTIDINE (COM) [108-48-5] ( RCHCG00083 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 26.29,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 56.39,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG01162-25001",
          "cmoLotNumber": "DRCHCG01162-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG01162",
          "cmoMaterialDescription": "TERT-BUTYLDIMETHYLSILYL TRIFLUOROMETHANESULFONATE (COM) [69739-34-0] ( RCHCG01162 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 56.39,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 42.4,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSTA25001",
          "cmoLotNumber": "DBSTA25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSTA001",
          "cmoMaterialDescription": "(S)-4-(2,7-DICHLORO-8-FLUOROPYRIDO[4,3-d]PYRIMIDIN-4-YL)-6-METHYL-1,4-OXAZEPAN-6-OL (BMT-933279) (STAGE-A) ( INTBSTA001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 21.35,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSTA25002",
          "cmoLotNumber": "DBSTA25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSTA001",
          "cmoMaterialDescription": "(S)-4-(2,7-DICHLORO-8-FLUOROPYRIDO[4,3-d]PYRIMIDIN-4-YL)-6-METHYL-1,4-OXAZEPAN-6-OL (BMT-933279) (STAGE-A) ( INTBSTA001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 21.05,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2458.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25019",
          "cmoLotNumber": "DRSLCG00056-25019",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 317.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25023",
          "cmoLotNumber": "DRSLCG00056-25023",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 553.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25024",
          "cmoLotNumber": "DRSLCG00056-25024",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1588.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 42.4,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00693-25025",
          "cmoLotNumber": "DRCHCG00693-25025",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00693",
          "cmoMaterialDescription": "SODIUM CHLORIDE (COM) [7647-14-5] ( RCHCG00693 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 9.71,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00693-25024",
          "cmoLotNumber": "DRCHCG00693-25024",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00693",
          "cmoMaterialDescription": "SODIUM CHLORIDE (COM) [7647-14-5] ( RCHCG00693 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 32.69,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 21.2,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02423-25001",
          "cmoLotNumber": "DRCHCG02423-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02423",
          "cmoMaterialDescription": "DI SODIUM HYDROGEN CITRATE (COM) [144-33-2] ( RCHCG02423 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 21.2,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02793-D25002",
          "cmoLotNumber": "DRCHCG02793-D25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02793",
          "cmoMaterialDescription": "3M ZETA PLUS ACTIVATED CARBON SERIES FILTER CARTRIDGE C16MA R55SP ( RCHCG02793 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 7.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00040-25023",
          "cmoLotNumber": "DPCNCT00040-25023",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00040",
          "cmoMaterialDescription": "HDPE DRUMS. MODEL : NMB-210, ( 8.5 KGS) BLUE COLOUR ( PCNCT00040 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 7.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1446.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00013-25028",
          "cmoLotNumber": "DRSLCG00013-25028",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00013",
          "cmoMaterialDescription": "ETHYL ACETATE (COM) [141-78-6] ( RSLCG00013 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 154.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00013-25034",
          "cmoLotNumber": "DRSLCG00013-25034",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00013",
          "cmoMaterialDescription": "ETHYL ACETATE (COM) [141-78-6] ( RSLCG00013 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1292.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 207.4382,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00024-25019",
          "cmoLotNumber": "DRSLCG00024-25019",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 80.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25005-07",
          "cmoLotNumber": "PDRSLCG00024-25005-07",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 127.4382,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 190.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02002-25001",
          "cmoLotNumber": "DRCHCG02002-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02002",
          "cmoMaterialDescription": "LITHIUM TERT-BUTOXIDE 2.0M IN THF (COM) [1907-33-1] ( RCHCG02002 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 190.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 44.22,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSUB25001",
          "cmoLotNumber": "DBSUB25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSUB001",
          "cmoMaterialDescription": "((4aS,7aR)-1-((2R,4r,6S)-2,6-DIMETHYLTETRAHYDRO-2H-PYRAN-4-YL)OCTAHYDRO-4aH-CYCLOPENTA[b]PYRIDIN-4a-YL)METHANOL HYDROGEN CHLORIDE (BMT-909920-02) (STAGE-B) ( INTBSUB001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 44.22,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25016",
          "cmoLotNumber": "DPPLBA00117-25016",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25071",
          "cmoLotNumber": "DPCNCT00034-25071",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTC25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25011",
          "cmoLotNumber": "DPPLBA00050-25011",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 8.4,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00643-25017",
          "cmoLotNumber": "DRCHCG00643-25017",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00643",
          "cmoMaterialDescription": "POTASSIUM HYDROXIDE FLACKS (COM) [1310-58-3] ( RCHCG00643 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.4,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 35.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSTC25001",
          "cmoLotNumber": "DBSTC25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSTC001",
          "cmoMaterialDescription": "(S)-6-((TERT-BUTYLDIMETHYLSILYL)OXY)-4-(7-CHLORO-2-(((4aS,7aR)-1-((2R,4r,6S)-2,6-DIMETHYLTETRAHYDRO-2H-PYRAN-4-YL)OCTAHYDRO-4aH-CYCLOPENTA[b]PYRIDIN-4a-YL)METHOXY)-8-FLUOROPYRIDO[4,3-d]PYRIMIDIN-4-YL)-6-METHYL-1,4-OXAZEPANE (INA-002584) (STAGE-C) ( INTBSTC001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 35.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.925,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02658-25001",
          "cmoLotNumber": "DRCHCG02658-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02658",
          "cmoMaterialDescription": "DICHLORO[9,9-DIMETHYL-4,5-BIS(DIPHENYLPHOSPHINO)XANTHENE]PALLADIUM(II) (COM) [205319-10-4] ( RCHCG02658 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.925,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 19.25,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 7.14,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02650-25001",
          "cmoLotNumber": "DRCHCG02650-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02650",
          "cmoMaterialDescription": "5-ETHYL-6-FLUORO-4-(4,4,5,5-TETRAMETHYL-1,3,2-DIOXABOROLAN-2-YL)NAPHTHALEN-2-OL (COM) [2763159-04-0] ( RCHCG02650 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2026-03-17T00:00:00.000Z",
          "expiryDate": "2026-03-17T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 19.25,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 7.14,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 885.39976,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25009",
          "cmoLotNumber": "DRCHCG00124-25009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 700.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25006",
          "cmoLotNumber": "DRCHCG00124-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 185.39976,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 70.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00693-25028",
          "cmoLotNumber": "DRCHCG00693-25028",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00693",
          "cmoMaterialDescription": "SODIUM CHLORIDE (COM) [7647-14-5] ( RCHCG00693 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 70.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.05,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00344-25001",
          "cmoLotNumber": "DRCHCG00344-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00344",
          "cmoMaterialDescription": "DI ISOPROPYL AZODICARBOXYLATE (COM) [2446-83-5] ( RCHCG00344 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.05,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.2,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02111-25006",
          "cmoLotNumber": "DRCHCG02111-25006",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02111",
          "cmoMaterialDescription": "AC-CYS-OH (COM) [616-91-1] ( RCHCG02111 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.2,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 17.5,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00316-25017",
          "cmoLotNumber": "DRCHCG00316-25017",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00316",
          "cmoMaterialDescription": "CITRIC ACID MONOHYDRATE (COM) [5949-29-1] ( RCHCG00316 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 17.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-25012",
          "cmoLotNumber": "DPPLBA00050-25012",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-25077",
          "cmoLotNumber": "DPCNCT00034-25077",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25018",
          "cmoLotNumber": "DPPLBA00117-25018",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 221.2,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-04",
          "cmoLotNumber": "PDRSLCG00038-25007-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 39.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25006-12",
          "cmoLotNumber": "PDRSLCG00038-25006-12",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 112.97,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-05",
          "cmoLotNumber": "PDRSLCG00038-25007-05",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 68.73,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1595.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25029",
          "cmoLotNumber": "DRSLCG00056-25029",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1420.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-25030",
          "cmoLotNumber": "DRSLCG00056-25030",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 175.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTD25001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPMSMS00148-25001",
          "cmoLotNumber": "DPMSMS00148-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PMSMS00148",
          "cmoMaterialDescription": "SILICA GEL 50 GMS PACK ( PMSMS00148 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Intermediate",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 48.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSTD25002",
          "cmoLotNumber": "DBSTD25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSTD001",
          "cmoMaterialDescription": "4-(4-((S)-6-((TERT-BUTYLDIMETHYLSILYL)OXY)-6-METHYL-1,4-OXAZEPAN-4-YL)-2-(((4aS,7aR)-1-((2R,4r,6S)-2,6-DIMETHYLTETRAHYDRO-2H-PYRAN-4-YL)OCTAHYDRO-4aH-CYCLOPENTA[b]PYRIDIN-4a-YL)METHOXY)-8-FLUOROPYRIDO[4,3-d]PYRIMIDIN-7-YL)-5-ETHYL-6-FLUORONAPHTHALEN-2-OL (BMT-933280) (STAGE-D) ( INTBSTD001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 16.95,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DBSTD25001",
          "cmoLotNumber": "DBSTD25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "INTBSTD001",
          "cmoMaterialDescription": "4-(4-((S)-6-((TERT-BUTYLDIMETHYLSILYL)OXY)-6-METHYL-1,4-OXAZEPAN-4-YL)-2-(((4aS,7aR)-1-((2R,4r,6S)-2,6-DIMETHYLTETRAHYDRO-2H-PYRAN-4-YL)OCTAHYDRO-4aH-CYCLOPENTA[b]PYRIDIN-4a-YL)METHOXY)-8-FLUOROPYRIDO[4,3-d]PYRIMIDIN-7-YL)-5-ETHYL-6-FLUORONAPHTHALEN-2-OL (BMT-933280) (STAGE-D) ( INTBSTD001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 31.05,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 784.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25010-04",
          "cmoLotNumber": "PDRSLCG00024-25010-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 400.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00024-25009-02",
          "cmoLotNumber": "PDRSLCG00024-25009-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00024",
          "cmoMaterialDescription": "TETRAHYDROFURAN (COM) [109-99-9] ( RSLCG00024 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 384.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 140.184,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00753-26001",
          "cmoLotNumber": "DRCHCG00753-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00753",
          "cmoMaterialDescription": "TETRA BUTYL AMMONIUM FLUORIDE, 1M IN THF (COM) [429-41-4] ( RCHCG00753 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 140.184,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 19.2,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00636-25011",
          "cmoLotNumber": "DRCHCG00636-25011",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00636",
          "cmoMaterialDescription": "POTASSIUM CARBONATE POWDER (COM) [584-08-7] ( RCHCG00636 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 19.2,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 48.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00693-25032",
          "cmoLotNumber": "DRCHCG00693-25032",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00693",
          "cmoMaterialDescription": "SODIUM CHLORIDE (COM) [7647-14-5] ( RCHCG00693 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 48.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 14.4,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00435-25026",
          "cmoLotNumber": "DRCHCG00435-25026",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00435",
          "cmoMaterialDescription": "HYDROCHLORIC ACID - CP (COM) [7647-01-0] ( RCHCG00435 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 14.4,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1362.76798,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRCHCG00124-25001-01",
          "cmoLotNumber": "PDRCHCG00124-25001-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 760.96613,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25009",
          "cmoLotNumber": "DRCHCG00124-25009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 121.80185,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00124-25011",
          "cmoLotNumber": "DRCHCG00124-25011",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00124",
          "cmoMaterialDescription": "2-METHYL TETRAHYDROFURAN (COM) 96-47-9] ( RCHCG00124 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 480.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 4.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00113-25002",
          "cmoLotNumber": "DPPLBA00113-25002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00113",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS. CAPACITY : 25 KG. SIZE : 18\" X 30\" ( PPLBA00113 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00029-25003",
          "cmoLotNumber": "DPCNCT00029-25003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00029",
          "cmoMaterialDescription": "HDPE DRUMS WIDE MOUTH OMB 10 LTRS CAPACITY ( PCNCT00029 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2197.30399,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00021-25006-06",
          "cmoLotNumber": "PDRSLCG00021-25006-06",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00021",
          "cmoMaterialDescription": "N-HEPTANE (COM) [142-82-5] ( RSLCG00021 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 985.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00021-25006-01",
          "cmoLotNumber": "PDRSLCG00021-25006-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00021",
          "cmoMaterialDescription": "N-HEPTANE (COM) [142-82-5] ( RSLCG00021 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 43.30399,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00021-25006-04",
          "cmoLotNumber": "PDRSLCG00021-25006-04",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00021",
          "cmoMaterialDescription": "N-HEPTANE (COM) [142-82-5] ( RSLCG00021 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 159.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00021-25008-01",
          "cmoLotNumber": "PDRSLCG00021-25008-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00021",
          "cmoMaterialDescription": "N-HEPTANE (COM) [142-82-5] ( RSLCG00021 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 201.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00021-25008-02",
          "cmoLotNumber": "PDRSLCG00021-25008-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00021",
          "cmoMaterialDescription": "N-HEPTANE (COM) [142-82-5] ( RSLCG00021 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 809.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 480.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00018-25093",
          "cmoLotNumber": "DRSLCG00018-25093",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00018",
          "cmoMaterialDescription": "METHYLTERTIARYBUTYLETHER (COM) [1634-04-4] ( RSLCG00018 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 480.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 788.418,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25009-01",
          "cmoLotNumber": "PDRSLCG00038-25009-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 15.768,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-11",
          "cmoLotNumber": "PDRSLCG00038-25007-11",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 286.8,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25008-06",
          "cmoLotNumber": "PDRSLCG00038-25008-06",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 110.6,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25007-13",
          "cmoLotNumber": "PDRSLCG00038-25007-13",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 7.9,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-25008-02",
          "cmoLotNumber": "PDRSLCG00038-25008-02",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 256.75,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-01",
          "cmoLotNumber": "PDRSLCG00038-26001-01",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 94.8,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "PDRSLCG00038-26001-09",
          "cmoLotNumber": "PDRSLCG00038-26001-09",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00038",
          "cmoMaterialDescription": "METHANOL (COM) (BENZENE CONTROLLED) [67-56-1] ( RSLCG00038 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 15.8,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 16.13,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25020",
          "cmoLotNumber": "DPPLBA00117-25020",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.13,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-25023",
          "cmoLotNumber": "DPPLBA00117-25023",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 15.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-26001",
          "cmoLotNumber": "DPPLBA00117-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 12.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26004",
          "cmoLotNumber": "DPCNCT00034-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26005",
          "cmoLotNumber": "DPCNCT00034-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00034-26010",
          "cmoLotNumber": "DPCNCT00034-26010",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00034",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 50 Ltr Cap. ( PCNCT00034 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 9.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPMSMS00148-26001",
          "cmoLotNumber": "DPMSMS00148-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PMSMS00148",
          "cmoMaterialDescription": "SILICA GEL 50 GMS PACK ( PMSMS00148 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": "2027-12-31T00:00:00.000Z",
          "expiryDate": "2027-12-31T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 9.0,
          "cmoOnHandAvailableQuantity": 526.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 8.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26001",
          "cmoLotNumber": "DPPLBA00050-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 7.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26002",
          "cmoLotNumber": "DPPLBA00050-26002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRGSGA00008-26009",
          "cmoLotNumber": "DRGSGA00008-26009",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RGSGA00008",
          "cmoMaterialDescription": "NITROGEN GAS CYLINDER (COM) [7727-37-9] ( RGSGA00008 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00248-25001",
          "cmoLotNumber": "DPPLBA00248-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00248",
          "cmoMaterialDescription": "TRANSPARENT POLYTHENE BAG (SIZE: 6\" X 8\") ( PPLBA00248 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 4.462,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00059-25001",
          "cmoLotNumber": "DPPLBA00059-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00059",
          "cmoMaterialDescription": "BLACK POLYTHENE BAG. SIZE: 6\" x 8\" ( PPLBA00059 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 3.888,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 2.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00048-25001",
          "cmoLotNumber": "DPPLBA00048-25001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00048",
          "cmoMaterialDescription": "BLACK POLYTHENE BAG (18” X 30” X 400 GAUGE) ( PPLBA00048 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": "2027-06-30T00:00:00.000Z",
          "expiryDate": "2027-06-30T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 2.0,
          "cmoOnHandAvailableQuantity": 21.067,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPMSMS00074-24002",
          "cmoLotNumber": "DPMSMS00074-24002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PMSMS00074",
          "cmoMaterialDescription": "SILICA GEL POUCHES 01 GRAM ( PMSMS00074 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 1.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 4.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNDR00050-23001",
          "cmoLotNumber": "DPCNDR00050-23001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNDR00050",
          "cmoMaterialDescription": "HDPE CONTAINER (FOMB)(80 L CAPACITY) ( PCNDR00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 1.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 4.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBSTE26001",
      "materialCode": "1463268",
      "materialDescription": "BMS-986523-01",
      "materialType": "Product",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 0.48,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DFINBSTE001-26001",
          "cmoLotNumber": "DFINBSTE001-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "FINBSTE001",
          "cmoMaterialDescription": "(S)-4-(2-(((4aS,7aR)-1-((2R,4r,6S)-2,6-DIMETHYLTETRAHYDRO-2H-PYRAN-4-YL)OCTAHYDRO-4aH-CYCLOPENTA[b]PYRIDIN-4a-YL)METHOXY)-7-(8-ETHYL-7-FLUORO-3-HYDROXYNAPHTHALEN-1-YL)-8-FLUOROPYRIDO[4,3-d]PYRIMIDIN-4-YL)-6-METHYL-1,4-OXAZEPAN-6-OL (BMS-986523-01) (STAGE-E) ( FINBSTE001 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 0.48,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBQCA26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 11.5,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02862-26002",
          "cmoLotNumber": "DRCHCG02862-26002",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02862",
          "cmoMaterialDescription": "(R)-2-((S)-1-AMINO-5-(TERT-BUTOXY)-1,5-DIOXOPENTAN-2-YL)-3-METHYL-1-OXOISOINDOLINE-5-CARBOXYLIC ACID(BMT-902164-01) (COM) ( RCHCG02862 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2026-12-22T00:00:00.000Z",
          "expiryDate": "2026-12-22T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 4.965,
          "cmoOnHandAvailableQuantity": 0.14,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG02862-26001",
          "cmoLotNumber": "DRCHCG02862-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG02862",
          "cmoMaterialDescription": "(R)-2-((S)-1-AMINO-5-(TERT-BUTOXY)-1,5-DIOXOPENTAN-2-YL)-3-METHYL-1-OXOISOINDOLINE-5-CARBOXYLIC ACID(BMT-902164-01) (COM) ( RCHCG02862 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 6.535,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBQCA26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 8.8,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRCHCG00661-25015",
          "cmoLotNumber": "DRCHCG00661-25015",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RCHCG00661",
          "cmoMaterialDescription": "P-TOLUENESULFONIC ACID MONOHYDRATE,(COM) [6192-52-5] ( RCHCG00661 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": "2027-09-30T00:00:00.000Z",
          "expiryDate": "2027-09-30T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 8.8,
          "cmoOnHandAvailableQuantity": 325.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBQCA26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 249.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26003",
          "cmoLotNumber": "DRSLCG00056-26003",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 220.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00056-26007",
          "cmoLotNumber": "DRSLCG00056-26007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00056",
          "cmoMaterialDescription": "ACETONITRILE (COM) (WC, NMT 0.10%) [75-05-8] ( RSLCG00056 )",
          "cmoInventoryUOM": "Lt",
          "inventoryUOM": "Lt",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 29.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBQCA26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 3.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPCNCT00033-26001",
          "cmoLotNumber": "DPCNCT00033-26001",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PCNCT00033",
          "cmoMaterialDescription": "HDPE DRUMS Wide Mouth OMB 30 Ltr Cap. ( PCNCT00033 )",
          "cmoInventoryUOM": "Each",
          "inventoryUOM": "Each",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 3.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBQCA26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 15.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00117-26007",
          "cmoLotNumber": "DPPLBA00117-26007",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00117",
          "cmoMaterialDescription": "TRANSPARENT ANTISTATIC POLYTHENE BAGS SIZE : 25\" X 42\" ( PPLBA00117 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 15.0,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBQCA26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 15.0,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DPPLBA00050-26004",
          "cmoLotNumber": "DPPLBA00050-26004",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "PPLBA00050",
          "cmoMaterialDescription": "BLACK POLYTHENE ANTISTATIC BAG (25” X 42”) ( PPLBA00050 )",
          "cmoInventoryUOM": "numbers",
          "inventoryUOM": "numbers",
          "cmoExpiryDate": "2028-02-29T00:00:00.000Z",
          "expiryDate": "2028-02-29T00:00:00.000Z",
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 15.0,
          "cmoOnHandAvailableQuantity": 6.1,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    },
    {
      "vendorName": "Sai Life Sciences - Unit IV",
      "brandOwnerName": "Bristol-Myers Squibb Company",
      "vendorPlant": "Sai Life Sciences - Unit IV",
      "storageLocationID": "DBQCA26001",
      "materialCode": "-",
      "materialDescription": "-",
      "materialType": "Raw Material",
      "latestInventoryUpdatedDate": null,
      "totalOnHandQuantity": 146.3,
      "totalNetAvailableQuantity": 0.0,
      "totalCommittedQuantity": 0.0,
      "lotNumbersList": [
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00010-26005",
          "cmoLotNumber": "DRSLCG00010-26005",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 28.5,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        },
        {
          "lotNumber": "-",
          "inventoryBatchNumber": "DRSLCG00010-26008",
          "cmoLotNumber": "DRSLCG00010-26008",
          "vendorName": "Sai Life Sciences - Unit IV",
          "vendorPlant": "Sai Life Sciences - Unit IV",
          "cmoVendorPlant": "Sai Life Sciences - Unit IV",
          "cmoMaterialCode": "RSLCG00010",
          "cmoMaterialDescription": "DIMETHYL FORMAMIDE (COM) [68-12-2] ( RSLCG00010 )",
          "cmoInventoryUOM": "Kg",
          "inventoryUOM": "Kg",
          "cmoExpiryDate": null,
          "expiryDate": null,
          "inventoryManufacturingDate": null,
          "onHandAvailableQuantity": 117.8,
          "cmoOnHandAvailableQuantity": 0.0,
          "netAvailableQuantity": 0.0,
          "committedQuantity": 0.0,
          "batchExpired": false,
          "batchNearExpiry": false,
          "cmoBatchExpired": false,
          "cmoBatchNearExpiry": false
        }
      ]
    }
  ],
  "totalNoOfRecords": 271,
  "numberOfPages": 1,
  "cmoLatestInventorySyncTime": null,
  "sponsorLatestInventorySyncTime": null
};

/* ---------------------------------------------------------------------------
 * FILTERS FOR THE STATIC SET
 *
 * The screen's filters normally travel to the API in the request body, so with
 * the data coming from this file instead they had nothing to act on. These two
 * functions put that back WITHOUT touching how the filter bar works: one
 * supplies the dropdown options, the other narrows the rows, and both read the
 * same payload above.
 *
 * Options come from the data rather than the API's own lists because the two do
 * not share vocabularies -- the API lists plant CODES, this data carries plant
 * names like "Sai Life Sciences - Unit IV", so a selection from the API's list
 * could never match a row here and every filter would empty the table.
 *
 * The shapes returned are the shapes the Autocompletes already expect
 * (organizationName / plantCode / storageLocationID / materialCode +
 * materialDescription / inventoryBatchNumber), so no dropdown markup changes.
 * ------------------------------------------------------------------------- */

const ALL = 'All';
const isAll = (v) => v == null || v === '' || v === ALL;
// The sheet's column is "CMO - MFG Plant", one combined value, so the CMO is
// the part before the first " - " and the whole string is the plant.
const cmoNameOf = (plant) => String(plant || '').split(' - ')[0].trim();
const uniqBy = (list, key) => {
  const seen = new Set();
  return list.filter((item) => {
    const k = key(item);
    if (!k || seen.has(k)) return false;
    seen.add(k);
    return true;
  });
};

/**
 * Dropdown options, derived from the static rows and narrowed by what is
 * already chosen — picking a batch leaves only the materials in that batch,
 * which is how the live filter bar behaves.
 */
export const staticPdInventoryOptions = (selected = {}) => {
  const groups = STATIC_PD_INVENTORY.inventoryDataList || [];
  const { cmo, plant, storageLocationID, materialCode, batchNumber } = selected;

  // A group is in scope for the OPTION lists when it satisfies every filter
  // other than the one whose options are being built, so each dropdown keeps
  // offering the choices that would actually return rows.
  const inScope = (g, ignore) =>
    (ignore === 'cmo' || isAll(cmo) || cmoNameOf(g.vendorPlant) === cmo) &&
    (ignore === 'plant' || isAll(plant) || g.vendorPlant === plant) &&
    (ignore === 'storageLocationID' || isAll(storageLocationID)
      || g.storageLocationID === storageLocationID) &&
    (ignore === 'materialCode' || isAll(materialCode)
      || (g.lotNumbersList || []).some((l) => l.cmoMaterialCode === materialCode)) &&
    (ignore === 'batchNumber' || isAll(batchNumber)
      || (g.lotNumbersList || []).some((l) => l.cmoLotNumber === batchNumber));

  const lotsOf = (ignore) =>
    groups.filter((g) => inScope(g, ignore)).flatMap((g) => g.lotNumbersList || []);

  return {
    // One CMO in this data set; kept as a list so the control is unchanged.
    cmos: uniqBy(
      groups.filter((g) => inScope(g, 'cmo')).map((g) => ({
        organizationId: cmoNameOf(g.vendorPlant),
        organizationName: cmoNameOf(g.vendorPlant),
      })),
      (o) => o.organizationName,
    ),
    plants: uniqBy(
      groups.filter((g) => inScope(g, 'plant')).map((g) => ({ plantCode: g.vendorPlant })),
      (o) => o.plantCode,
    ),
    storageLocationIDs: uniqBy(
      groups.filter((g) => inScope(g, 'storageLocationID'))
        .map((g) => ({ storageLocationID: g.storageLocationID })),
      (o) => o.storageLocationID,
    ),
    materialCodes: uniqBy(
      lotsOf('materialCode').map((l) => ({
        materialCode: l.cmoMaterialCode,
        materialDescription: l.cmoMaterialDescription,
      })),
      (o) => o.materialCode,
    ),
    batchNumbers: uniqBy(
      lotsOf('batchNumber').map((l) => ({ inventoryBatchNumber: l.cmoLotNumber })),
      (o) => o.inventoryBatchNumber,
    ),
  };
};

/**
 * The payload narrowed by the current selection, in the same shape as the
 * unfiltered one so the screen cannot tell the two apart.
 *
 * Material code and batch number match at LOT level, so a material row keeps
 * only the lots that matched rather than being shown whole — the same thing the
 * API's own filtering does.
 */
export const filterStaticPdInventory = (selected = {}) => {
  const { cmo, plant, storageLocationID, materialCode, batchNumber } = selected;
  const groups = STATIC_PD_INVENTORY.inventoryDataList || [];

  const filtered = groups
    .filter((g) => (isAll(cmo) || cmoNameOf(g.vendorPlant) === cmo))
    .filter((g) => (isAll(plant) || g.vendorPlant === plant))
    .filter((g) => (isAll(storageLocationID) || g.storageLocationID === storageLocationID))
    .map((g) => {
      const lots = (g.lotNumbersList || [])
        .filter((l) => (isAll(materialCode) || l.cmoMaterialCode === materialCode))
        .filter((l) => (isAll(batchNumber) || l.cmoLotNumber === batchNumber));
      if (!lots.length) return null;
      const sum = (f) => Number(
        lots.reduce((n, l) => n + (Number(l[f]) || 0), 0).toFixed(5),
      );
      return {
        ...g,
        lotNumbersList: lots,
        // Recomputed from the surviving lots, so the totals a row shows always
        // describe what is under it.
        totalOnHandQuantity: sum('onHandAvailableQuantity'),
        totalNetAvailableQuantity: sum('netAvailableQuantity'),
        totalCommittedQuantity: sum('committedQuantity'),
      };
    })
    .filter(Boolean);

  return {
    ...STATIC_PD_INVENTORY,
    inventoryDataList: filtered,
    totalNoOfRecords: filtered.length,
    numberOfPages: 1,
  };
};

export default STATIC_PD_INVENTORY;
